export const RADIUS_STEP = 5
export const MIN_RADIUS = 5
export const MAX_RADIUS = 100
export const BULK_RADIUS_PRESETS = [5, 10, 15, 20, 25, 30, 40, 50]

export const clampRadius = (radius: number): number => Math.min(MAX_RADIUS, Math.max(MIN_RADIUS, radius))

export const stepRadius = (radius: number | null | undefined, direction: 1 | -1): number =>
  clampRadius((radius ?? MIN_RADIUS) + direction * RADIUS_STEP)
